import { useParams } from 'react-router-dom';

import NameYourFamilyOffice from "./NameYourFamilyOffice";
import AboutTransactions from "./AboutTransactions";
import AboutPayees from "./AboutPayees";
import AboutMatchExpressions from "./AboutMatchExpressions";
import AboutTransfers from "./AboutTransfers";
import FixAPayee from "./FixAPayee";

export default function OnRamp() {
  const {step} = useParams();


  if(!step || step === "1")
    return <NameYourFamilyOffice index={1}/>
  else if(step === "2")
    return <AboutTransactions index={2}/>
  else if(step === "3")
    return <AboutPayees index={3}/>
  else if(step === "4")
    return <AboutMatchExpressions index={4}/>
  else if(step === "5")
    return <AboutTransfers index={5}/>
  else if(step === "6")
    return <FixAPayee index={6}/>
  else
    return <h1>Unknown Step</h1>
}

